export enum ErrorsCodeEnum {
  NOT_AUTHENTICADED = 111,
  USER_TYPE_NOT_ALLOWED = 114
}
